module.exports = __webpack_public_path__ + "static/media/car_noti.923539fe.svg";